<style scoped lang="scss">
  .main-top{
    padding:0 15px;
    background: url("../../assets/images/mobile/top_bg.png") no-repeat left -50px;
    background-size: 100% auto;
    .logo{
      width:120px;
      margin:30px 0;
    }
    .card-lists{
      background: #fff;
      box-shadow: 0 2px 6px rgba(0,0,0,.1);
      padding:10px 15px;
      li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding:20px 0;
        border-bottom: 1px solid #F5F5F5;
        font-size: 14px;
        &:last-child{
          border-bottom: 0;
        }
        .icon{
          width:20px;
          margin-right: 5px;
        }
        .arrow{
          width:8px;
          margin-left: 5px;
        }
        .label{
          display: flex;
          align-items: center;
        }
        .info{
          display: flex;
          align-items: center;
          color: #999;
        }
      }
    }
  }
  .btn-action{
    position: fixed;
    left:30px;
    right:30px;
    bottom:60px;
  }
</style>
<style>
.app-confirm{
  width:300px !important;
}
</style>
<template>
  <div class="wrap-app">
    <qk-back/>
    <div class="main-top">
      <div class="tc"><img src="@/assets/images/mobile/logo.png" class="logo"></div>
      <ul class="card-lists">
        <li>
          <div class="label">
            <img src="@/assets/images/mobile/icon_user.png" class="icon">
            姓名
          </div>
          <div class="info">
            {{username}}
          </div>
        </li>
        <li>
          <div class="label">
            <img src="@/assets/images/mobile/icon_phone.png" class="icon">
            手机号码
          </div>
          <div class="info">
            {{userPhone}}
          </div>
        </li>
      </ul>
    </div>
    <div class="btn-action">
      <button class="btn btn-sencond btn-block" @click="unbind">解除账号绑定</button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      userPhone: ''
    }
  },
  created() {
    const memberInfo = this.baseMethods.getLocalObj('memberInfo')
    const { mobile, realName } = memberInfo
    this.username = realName
    this.userPhone = `${mobile.slice(0, 3)}****${mobile.slice(7)}`
  },
  methods: {
    // 解除账号绑定
    unbind () {
      this.$confirm('确定解除账号绑定', '提示', {customClass: 'app-confirm'}).then(res => {
        localStorage.clear()
        this.$toast('已解除绑定')
        this.username = ''
        this.userPhone = ''
        this.baseMethods.hrefUrl('/mobile/login')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mobile/unbind.vue